import { initialUIState } from './../states/ui.state';
import { EUIActions, UIActions } from '../actions/ui.actions';
import { ActionReducer, Action } from '@ngrx/store';

export const uiReducers: ActionReducer<typeof initialUIState, Action<string>> = (state = initialUIState, action: Action<string>) => {
    switch (action.type) {
      case EUIActions.SetUsername: {
          return {
              ...state,
              username: (action as UIActions).payload
          };
      }
        default:
            return state;
    }
}

